import _typeof from "@babel/runtime/helpers/typeof";
export var isDeepEqual = function isDeepEqual(x, y) {
  return !!(x && y && _typeof(x) === 'object' && _typeof(y) === 'object' ? Object.keys(x).length === Object.keys(y).length && Object.keys(x).reduce(function (isEqual, key) {
    return isEqual && isDeepEqual(x[key], y[key]);
  }, true) : x === y);
};